<template>
  <div :class="[$style.item, $style[`item_${index}`]]">
    <div :class="$style.item_wrap">
      <img :src="require(`./images/college-course-pic-${index}.jpg`)" />
      <div :class="$style.item_tag" />
    </div>
  </div>
</template>

<script>
export default {
  props: { index: { type: Number, default: 1 } },
}
</script>

<style lang="less" module>
.item-size(@r: 1) {
  .size(4.14rem * @r, 3.67rem * @r);

  &_wrap {
    .size(3.28rem * @r, 2.75rem * @r);
  }
}

.tag-size(@r: 1) {
  &::before {
    height: 0.83rem * @r;
  }

  &::after {
    .size(1.72rem * @r, 2.38rem * @r);
  }
}

.item {
  .item-size();
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.1rem;

  &_wrap {
    position: relative;
    border-radius: 0 0.4rem 0 0.4rem;
    background-color: #fff;
    overflow: hidden;
    transition: width 0.3s, height 0.3s;

    img {
      .size(100%);
    }

    .item:hover & {
      .size(100%);
      box-shadow: 0.04rem 0.04rem 0 #4f79bc;
    }
  }

  &_tag {
    .size(100%);
    .tag-size();
    position: absolute;
    top: 0;
    left: 0;
    transition: background-color 0.3s;

    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
    }

    &::before {
      bottom: 0;
      background-color: #fff;
    }

    &::after {
      top: 2.14rem;
      margin: 0 auto;
      background: url('./images/college-course-text.png') no-repeat;
      background-size: 300% 100%;
      transition: top 0.5s;

      .item_1 & {
        background-position: 0 0;
      }

      .item_2 & {
        background-position: 50% 0;
      }

      .item_3 & {
        background-position: 100% 0;
      }
    }

    .item:hover & {
      background-color: fade(#fff, 90%);

      &::before {
        content: none;
      }

      &::after {
        top: 0.77rem;
      }
    }
  }
}

@media screen and (max-width: @mini-width) {
  .item {
    .item-size(1.4);

    &_tag {
      .tag-size(1.8);

      &::after {
        top: 2.7rem;
      }

      .item:hover & {
        &::after {
          top: 0.6rem;
        }
      }
    }
  }
}
</style>
